import React from 'react';
import loadable from '@loadable/component';

import { ModuleSelectorProps } from 'modules/shared/types';

export const ModuleSelector: React.FC<ModuleSelectorProps> = ({ structureNode, ...rest }: ModuleSelectorProps) => {
    switch (structureNode.contentTemplate) {
        case 'CatalogueEntry': {
            const CatalogueModule = loadable(() =>
                import(/* webpackChunkName: "catalogue" */ '../../../../modules/catalogue/redirection-catalogue'),
            );

            return <CatalogueModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'CreationListeEntry': {
            const CreationListeModule = loadable(() =>
                import(/* webpackChunkName: "creation-liste" */ '../../../../modules/creation-liste/creation-liste'),
            );

            return <CreationListeModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'PartenairesEntry': {
            const PartenairesModule = loadable(() =>
                import(/* webpackChunkName: "partenaires" */ '../../../../modules/partenaires/partenaires'),
            );

            return <PartenairesModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'EspacePersoEntry': {
            const EspacePersoModule = loadable(() =>
                import(/* webpackChunkName: "espace-perso" */ '../../../../modules/espace-perso/espace-perso'),
            );
            return <EspacePersoModule sourceStructureNode={structureNode} {...rest} />;
        }
        case 'MariageEntry': {
            const MariageModule = loadable(() =>
                import(/* webpackChunkName: "mariage" */ '../../../../../mariage/mariage'),
            );
            return <MariageModule sourceStructureNode={structureNode} {...rest} />;
        }
        default:
            return <React.Fragment>Module not found</React.Fragment>;
    }
};
